module.exports = __webpack_public_path__ + "img/cy.e6e796b5.png";